import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-sidenav-toggle-btn',
  templateUrl: './sidenav-toggle-btn.component.html',
  styleUrls: ['./sidenav-toggle-btn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidenavToggleBtnComponent implements OnChanges {
  icon = 'arrow_left';
  @Input() offset = 0;
  constructor() {}

  ngOnChanges(changes) {
    this.icon = this.getIcon(changes.offset.currentValue);
  }

  getClasses() {
    return {
      'sidenav-toggle-btn-close': this.offset === 0 ? false : true,
      'sidenav-toggle-btn-open': this.offset === 0 ? true : false
    };
  }

  getStyles() {
    return { 'left.px': this.offset };
  }

  getIcon(offset) {
    const icon = offset === 0 ? 'arrow_right' : 'arrow_left';
    return icon;
  }
}
